<template>
  <div class="embed-responsive embed-responsive-16by9">
    <iframe
      class="embed-responsive-item"
      src="https://www.youtube.com/embed/jKGkermaPoA?rel=0"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
    />
  </div>
</template>

<script>
export default {
  //
}
</script>
